import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomersComponent } from './customers/customers.component';
import { CreateOrEditCustomerComponent } from './customers/create-or-edit-customer.component';
import { SalespersonsComponent } from './salespersons/salespersons.component';
import { CreateOrEditSalespersonModalComponent } from './salespersons/create-or-edit-salesperson-modal.component';
import { SalesOrdersComponent } from './salesOrders/salesOrders.component';
import { CreateOrEditSalesOrderComponent } from './salesOrders/create-or-edit-salesOrder.component';
import { SalesInvoicesComponent } from './salesInvoices/salesInvoices.component';
import { CreateOrEditSalesInvoiceComponent } from './salesInvoices/create-or-edit-salesInvoice.component';
import { SalesReturnsComponent } from './salesReturns/salesReturn.component';
import { CreateOrEditSalesReturnComponent } from './salesReturns/create-or-edit-salesReturn.component';
import { CustomerPaymentsComponent } from './customerPayments/customerPayments.component';
import { CreateOrEditCustomerPaymentComponent } from './customerPayments/create-or-edit-customerPayment.component';
import { CustomerSalesAnalysisComponent } from './reports/customer-sales-analysis/customer-sales-analysis.component';
import { CustomerSalesAnalysisByLocationComponent } from './reports/customer-sales-analysis-by-location/customer-sales-analysis-by-location.component';
import { CustomerSalesSummaryComponent } from './reports/customer-sales-summary/customer-sales-summary.component';
import { DailySalesDetailComponent } from './reports/daily-sales-detail/daily-sales-detail.component';
import { DailySalesRetunrDetailComponent } from './reports/daily-sales-retunr-detail/daily-sales-retunr-detail.component';
import { DailyDeliveryOrderComponent } from './reports/delivery-order/daily-delivery-order/daily-delivery-order.component';
import { DailyDeliveryOrderDetailComponent } from './reports/delivery-order/daily-delivery-order-detail/daily-delivery-order-detail.component';
import { DeliveryOrderDetailComponent } from './reports/delivery-order/delivery-order-detail/delivery-order-detail.component';
import { DepartmentSalesSummaryComponent } from './reports/department-sales-summary/department-sales-summary.component';
import { ItemSalesSummaryComponent } from './reports/item-sales-summary/item-sales-summary.component';
import { ItemSalesSummaryByCustomerComponent } from './reports/item-sales-summary-by-customer/item-sales-summary-by-customer.component';
import { PaymentDetailComponent } from './reports/payment-detail/payment-detail.component';
import { PaymentSummaryComponent } from './reports/payment-summary/payment-summary.component';
import { SalesAccountActivityComponent } from './reports/sales-account-activity/sales-account-activity.component';
import { SalesAgedReceivablesComponent } from './reports/sales-aged-receivables/sales-aged-receivables.component';
import { SalesAgedReceivablesDetailsComponent } from './reports/sales-aged-receivables-details/sales-aged-receivables-details.component';
import { SalesDetailComponent } from './reports/sales-detail/sales-detail.component';
import { DailySalesOrderComponent } from './reports/sales-order/daily-sales-order/daily-sales-order.component';
import { DailySalesOrderDetailComponent } from './reports/sales-order/daily-sales-order-detail/daily-sales-order-detail.component';
import { SalesOrderDetailComponent } from './reports/sales-order/sales-order-detail/sales-order-detail.component';
import { SalesOutstandingInvoicesComponent } from './reports/sales-outstanding-invoices/sales-outstanding-invoices.component';
import { SalesProductAnalysisComponent } from './reports/sales-product-analysis/sales-product-analysis.component';
import { SalesRebateComponent } from './reports/sales-rebate/sales-rebate.component';
import { SalesReturnDetailComponent } from './reports/sales-return-detail/sales-return-detail.component';
import { SalesmanAnalysisComponent } from './reports/salesman-analysis/salesman-analysis.component';
import { SalesmanSalesSummaryComponent } from './reports/salesman-sales-summary/salesman-sales-summary.component';

const routes: Routes = [
  {
    path: 'customers',
    children: [
      {
        path: '',
        component: CustomersComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditCustomerComponent,
      }
    ]
    },
  {
    path: 'salespersons',
    children: [
      {
        path: '',
        component: SalespersonsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditSalespersonModalComponent,
      }
    ]
    },
    
    {
        path: 'salesOrders',
        children: [
            {
                path: '',
                component: SalesOrdersComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditSalesOrderComponent,
            }
        ]
    },
    {
        path: 'salesInvoices',
        children: [
            {
                path: '',
                component: SalesInvoicesComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditSalesInvoiceComponent,
            }
        ]
    },
    {
        path: 'salesReturns',
        children: [
            {
                path: '',
                component: SalesReturnsComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditSalesReturnComponent,
            }
        ]
    },
    {
        path: 'customerPayments',
        children: [
            {
                path: '',
                component: CustomerPaymentsComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditCustomerPaymentComponent,
            }
        ]
    },
    {
        path: 'customer-sales-analysis',
        children: [
            {
              path: '',
              component: CustomerSalesAnalysisComponent,
            }
        ]
    },
    {
        path: 'customer-sales-analysis-by-location',
        children: [
            {
              path: '',
              component: CustomerSalesAnalysisByLocationComponent,
            }
        ]
    },
    {
        path: 'customer-sales-summary',
        children: [
            {
              path: '',
              component: CustomerSalesSummaryComponent,
            }
        ]
    },
    {
        path: 'daily-sales-detail',
        children: [
            {
              path: '',
              component: DailySalesDetailComponent,
            }
        ]
    },
    {
        path: 'daily-sales-retunr-detail',
        children: [
            {
              path: '',
              component: DailySalesRetunrDetailComponent,
            }
        ]
    },
        {
        path: 'daily-delivery-order',
        children: [
            {
              path: '',
              component: DailyDeliveryOrderComponent,
            }
        ]
    },
    {
        path: 'daily-delivery-order-detail',
        children: [
            {
              path: '',
              component: DailyDeliveryOrderDetailComponent,
            }
        ]
    },
    {
        path: 'delivery-order-detail',
        children: [
            {
              path: '',
              component: DeliveryOrderDetailComponent,
            }
        ]
    },
    {
        path: 'department-sales-summary',
        children: [
            {
              path: '',
              component: DepartmentSalesSummaryComponent,
            }
        ]
    },
        {
        path: 'item-sales-summary',
        children: [
            {
              path: '',
              component: ItemSalesSummaryComponent,
            }
        ]
    },
    {
        path: 'item-sales-summary-by-customer',
        children: [
            {
              path: '',
              component: ItemSalesSummaryByCustomerComponent,
            }
        ]
    },
    {
        path: 'payment-detail',
        children: [
            {
              path: '',
              component: PaymentDetailComponent,
            }
        ]
    },
    {
        path: 'payment-summary',
        children: [
            {
              path: '',
              component: PaymentSummaryComponent,
            }
        ]
    },
        {
        path: 'sales-account-activity',
        children: [
            {
              path: '',
              component: SalesAccountActivityComponent,
            }
        ]
    },
    {
        path: 'sales-aged-receivables',
        children: [
            {
              path: '',
              component: SalesAgedReceivablesComponent,
            }
        ]
    },
    {
        path: 'sales-aged-receivables-details',
        children: [
            {
              path: '',
              component: SalesAgedReceivablesDetailsComponent,
            }
        ]
    },
    {
        path: 'sales-detail',
        children: [
            {
              path: '',
              component: SalesDetailComponent,
            }
        ]
    },
        {
        path: 'daily-sales-order',
        children: [
            {
              path: '',
              component: DailySalesOrderComponent,
            }
        ]
    },
    {
        path: 'daily-sales-order-detail',
        children: [
            {
              path: '',
              component: DailySalesOrderDetailComponent,
            }
        ]
    },
    {
        path: 'sales-order-detail',
        children: [
            {
              path: '',
              component: SalesOrderDetailComponent,
            }
        ]
    },
    {
        path: 'sales-outstanding-invoices',
        children: [
            {
              path: '',
              component: SalesOutstandingInvoicesComponent,
            }
        ]
    },
    {
        path: 'sales-product-analysis',
        children: [
            {
              path: '',
              component: SalesProductAnalysisComponent,
            }
        ]
    },
    {
        path: 'sales-rebate',
        children: [
            {
              path: '',
              component: SalesRebateComponent,
            }
        ]
    },
    {
        path: 'sales-return-detail',
        children: [
            {
              path: '',
              component: SalesReturnDetailComponent,
            }
        ]
    },
    {
        path: 'salesman-analysis',
        children: [
            {
              path: '',
              component: SalesmanAnalysisComponent,
            }
        ]
    },
    {
        path: 'salesman-sales-summary',
        children: [
            {
              path: '',
              component: SalesmanSalesSummaryComponent,
            }
        ]
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesRoutingModule { }
